var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChristmasStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2217 7.01523L9.28462 9.24627C9.17082 9.51721 8.92648 9.70304 8.64513 9.73261L3.70683 10.2516C3.02781 10.3229 2.75392 11.2053 3.26319 11.6808L6.96694 15.139C7.17795 15.3361 7.27128 15.6367 7.2112 15.9259L6.15672 21.0025C6.01172 21.7005 6.72877 22.2459 7.31818 21.8858L11.6048 19.2673C11.7269 19.1927 11.8634 19.1554 12 19.1554C12.1366 19.1554 12.2731 19.1927 12.3952 19.2673L16.6818 21.8858C17.2712 22.2459 17.9883 21.7005 17.8433 21.0025L16.7888 15.9259C16.7287 15.6367 16.8221 15.3361 17.0331 15.139L20.7368 11.6808C21.2461 11.2053 20.9722 10.3229 20.2932 10.2516L15.3549 9.73261C15.0735 9.70304 14.8292 9.51722 14.7154 9.24627L13.7783 7.01523C13.2571 7.32325 12.6492 7.50001 12 7.50001C11.3508 7.50001 10.7429 7.32325 10.2217 7.01523Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasStar);
export default __webpack_public_path__ + "static/media/christmas-star.0a71881eb15bef185f9089ce3e6de08c.svg";
export { ForwardRef as ReactComponent };